import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  input,
  Input,
  model,
  OnInit,
  output,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CtDocument, CtDocumentId } from '../../model/ct-batch-model';
import { PreviewDocumentThumbnailComponent } from './preview-document-thumbnail/preview-document-thumbnail.component';
import { PreviewPageThumbnailComponent } from './preview-page-thumbnail/preview-page-thumbnail.component';
import { NgClass } from '@angular/common';
import { DocumentClassFilterComponent } from './document-class-filter/document-class-filter.component';

@Component({
  selector: 'ct-shared-preview-thumbnail-bar',
  imports: [
    PreviewDocumentThumbnailComponent,
    PreviewPageThumbnailComponent,
    NgClass,
    DocumentClassFilterComponent,
  ],
  templateUrl: './preview-thumbnail-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewThumbnailBarComponent implements OnInit {
  readonly _currentPageIndex = input<number>(0);

  private readonly _ = effect(() => {
    if (this.isSingleDocumentView()) {
      this.scrollToChildAtIndex(this._currentPageIndex());
    }
  });

  readonly documentClassFilterEnabled = input(false);
  readonly availableDocumentClasses = input<string[]>([]);
  readonly selectedDocumentClasses = model.required<string[]>();

  protected _selectedDocumentId!: string;

  @Input({ required: true }) set selectedDocumentId(id: string) {
    this._selectedDocumentId = id;
    this.scrollToChildAtIndex(this.documents().findIndex((document) => document.id === id));
  }

  get selectedDocumentId() {
    return this._selectedDocumentId;
  }

  readonly documents = input.required<CtDocument[]>();
  readonly singleOpenedDocument = input<CtDocument>();
  readonly documentLabelTemplate = input<TemplateRef<{ $implicit: CtDocument }>>();
  readonly documentThumbnailOverlayTemplate = input<TemplateRef<{ $implicit: CtDocument }>>();

  readonly isSingleDocumentView = input.required<boolean>();

  readonly isPreviewListExpandedOrHovered = input.required<boolean>();

  @Output() thumbnailPageSelected = new EventEmitter<string>();

  documentThumbnailSelected = output<CtDocumentId>();

  @ViewChild('pagePreviewList') pagePreviewList?: ElementRef<HTMLDivElement>;

  private scrollToChildAtIndex(index: number) {
    if (!this.pagePreviewList) return;

    const child = this.pagePreviewList.nativeElement.children[index];
    if (!child) {
      console.warn(
        `Could not scroll to child at index ${index} because it's undefined. PagePreviewList children length: ${this.pagePreviewList.nativeElement.children.length}`,
      );
      return;
    }

    child.scrollIntoView({
      behavior: 'instant',
      block: 'center',
    });
  }

  ngOnInit(): void {
    this.selectedDocumentId = this.documents()[0].id;
  }

  scrollToFirstPageOfDocument(documentIndex: number) {
    const document = this.documents()[documentIndex];
    this.selectPage(document.pages[0].id);
    this.documentThumbnailSelected.emit({ documentId: document.id });
  }

  selectPage(pageId: string) {
    this.thumbnailPageSelected.emit(pageId);
  }
}
